export enum EInputCustomType {
  Email = 'email',
  Text = 'text',
  Password = 'password',
  Number = 'number',
  Textarea = 'textarea'
}

export enum EInputSupportMessage {
  FieldRequired = 'Field required',
  Email = 'Please enter a valid email address',
  EmailNotFound = 'This email isn’t linked to a JustSext account. Use this email to',
  EmailExists = 'This email is linked to a JustSext account. Use this email to',
  Password = 'Must be minimum 8 characters with at least one number, uppercase and lowercase letter and symbol.',
  PasswordMatch = 'Must contain at least 1 number, special character, uppercase letter, and lowercase letter.',
  PasswordRequired = 'Password required',
  PasswordHint = 'Must contain at least 1 number, special character, uppercase letter, and lowercase letter',
  ForgotPassword = 'Forgot password',
  ZipRequired = 'ZIP or postal code required',
  FirstNameRequired = 'First name required',
  LastNameRequired = 'Last name required',
  VerifyCodeRequired = 'Please enter a 6-digit code',
  VerifyCodeError = 'Verification code is expired or invalid. Check your email for a new one.',
  NameMaxLength = 'Name must not exceed 30 characters',
  ApiError = 'An error occurred. Please try again.'
}

export enum EInputUsage {
  Page = 'page',
  Modal = 'modal'
}
